// extracted by mini-css-extract-plugin
export default {"image":"CardImage_image__WgJzW"};